export default __webpack_public_path__ + "8dc903348de81a218f08bd71e8fdc18c.ttf";